import React from 'react';
import PropTypes from 'prop-types';
import classes from './InstructorB.module.scss';

const { string, shape } = PropTypes;

const InstructorBioB = (props) => {
  const {
    title,
    heading,
    content,
    additionalContent,
    image,
  } = props;

  const { url, altText } = image || {};

  const instructorImage = (
    url && <img
      className={classes.image}
      src={url}
      alt={altText}
      width={100}
      height={100}
      loading='lazy'
      aria-hidden
    />
  );

  const description = `${content}${additionalContent ? `\n\n${additionalContent}` : ''}`;

  return (
    <div className={classes.container}>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classes.wrapper}>
        {instructorImage && <div className={classes.imageWrapper}>{instructorImage}</div>}
        <div className={classes.contentWrapper}>
          <div className={classes.headerWrapper}>
            {instructorImage && <div className={classes.mobileImageWrapper}>{instructorImage}</div>}
            {heading && <div
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: heading }}
            />}
          </div>
          {description && <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: description }}
          />}
        </div>
      </div>
    </div>
  );
};

InstructorBioB.propTypes = {
  /**
   * title of the page
  */
  title: string,
  /**
   * Heading of the bio
  */
  heading: string,
  /**
   * Content of the bio
  */
  content: string,
  /**
   * Additional Content of the bio
  */
  additionalContent: string,
  /**
   * Image Object
  */
  image: shape({
    url: string,
    altText: string,
  }),
};

export default InstructorBioB;
